import React from "react";
import { Provider as ReduxProvider } from "inbooma-api";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

type Props = {
  store: unknown;
  children?: React.ReactNode;
};

export const queryClient = new QueryClient();

export const Provider = ({ store, children }: Props) => (
  <QueryClientProvider client={queryClient}>
    <ReduxProvider store={store}>{children}</ReduxProvider>
  </QueryClientProvider>
);

export default Provider;
